import { fetchJsonResponse } from '@/ai/api'
import { buildSingleEventPrompt } from '@/ai/prompts'

export const generateSingleEvent = async ({
  parentEventId,
  workflow,
  cardTypes,
  abortController
}) => {
  if (!workflow || !workflow.aiVersion) {
    return null
  }

  const messages = buildSingleEventPrompt({
    parentEventId,
    workflow,
    cardTypes
  })

  const response = await fetchJsonResponse({
    messages,
    useCase: 'workflow-diagram',
    aiVersion: workflow.aiVersion,
    signal: abortController?.signal
  })

  return response || null
}
